"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getEnumDumpingData = exports._putHopperConfigData = exports._getHopperConfigData = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("utils/constants");
const error_response_1 = require("utils/error-response");
const getFromLocalStorage = {
    token: () => {
        const token = localStorage.getItem(constants_1.localStorageKey.token);
        if (token)
            return token;
        return '';
    }
};
const _getHopperConfigData = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/configuration/checkpoint';
    const filterString = filter ? JSON.stringify({
        logic: filter.logic,
        filters: filter.filters.concat({ field: 'type', operator: 'contains', value: 'hopper' })
    }) : JSON.stringify({
        filters: [{ field: 'type', operator: 'contains', value: 'hopper' }]
    });
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            countData: 0
        };
    }
});
exports._getHopperConfigData = _getHopperConfigData;
const _putHopperConfigData = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/configuration/checkpoint/${arg.checkpoint_id}`;
    try {
        if (arg.brand1_id === '0')
            delete arg.brand1_id;
        if (arg.brand2_id === '0')
            delete arg.brand2_id;
        if (arg.brand3_id === '0')
            delete arg.brand3_id;
        const { data } = yield axios_1.default.put(url, arg, {
            headers: {
                'X-User-Token': getFromLocalStorage.token()
            }
        });
        return {
            isError: false,
            errorMessage: '',
            errorCode: 0,
            data: {
                id: data.data.id
            }
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: {
                id: ''
            }
        };
    }
});
exports._putHopperConfigData = _putHopperConfigData;
const _getEnumDumpingData = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/master-data/enum';
    const filter = {
        logic: 'and',
        filters: [
            { field: 'type', operator: 'contains', value: 'Dumping Hopper' }
        ]
    };
    const filterString = JSON.stringify(filter);
    const config = {
        params: { skip: 0, take: 100, filter: filterString },
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const { data } = yield axios_1.default.get(url, config);
        return {
            isError: false,
            errorMessage: '',
            errorCode: 0,
            data: data.data
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            contractor: []
        };
    }
});
exports._getEnumDumpingData = _getEnumDumpingData;
